<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="login-container">

  </div>
</template>

<script>
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { setToken, removeToken } from '@/utils/auth';
import { VUE_APP_BASE_API, getEnvGlobalConfig } from '@/utils/index';
export default {
  name: 'Auth',
  data() {
    return {
      fullscreenLoading: false,
    };
  },
  created() {
    this.fullscreenLoading = true; // 全屏加载
    NProgress.start(); // 进度条加载
    const DEFAULT_ACCESS_TOKEN = getEnvGlobalConfig('VUE_APP_ACCESS_TOKEN');
    const { access_token } = this.$route.query; // 获取access_token
    const ACCESS_TOKEN = access_token || DEFAULT_ACCESS_TOKEN;
    if (!ACCESS_TOKEN) {
      // 没有token直接重定向到中心登录页
      const authApiHost = VUE_APP_BASE_API();
      const clientId = getEnvGlobalConfig('VUE_APP_CLIENT_ID');
      const redirectUri = encodeURIComponent(
        `${window.location.origin}/#/login?BJtime=${Math.random()}`,
      );
      const urlHref = `${authApiHost}/oauth/oauth/authorize?response_type=token&client_id=${clientId}&redirect_uri=${redirectUri}`;
      window.location.replace(urlHref);
      removeToken(); // 移除token
      return;
    }
    this.$store.dispatch('user/setToken', ACCESS_TOKEN);
    setToken(ACCESS_TOKEN); // 有的话存储token
    // 增加请求用户信息的接口
    NProgress.done();
    this.$message.success(this.$t('loginSucceededText'));

    this.$store.dispatch('user/getInfo').then(res => {
      NProgress.done();
      this.$router.replace({ path: '/' }); // 进入首页
    });
    this.$router.replace({ path: '/' }); // 进入首页
  },
  methods: {},
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-tabs__item {
    color: white;
    &:hover,
    &.is-active {
      color: #4c83ff;
    }
    &.is-focus {
      border: none;
      outline: none;
    }
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
.vercode {
  ::v-deep .el-form-item__content {
    display: flex;
  }
}
</style>
